import React from "react";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import ImageIcon from "@material-ui/icons/Image";
import TestChoices from "./AnswerChoices";
import TestChoicesTrueFalse from "./AnswerChoicesTrueFalse";
import TestChoicesMultiple from "./AnswerChoicesMultiple";
import TestShortAnswer from "./AnswerShort";
import TestMenjodohkan from "./AnswerMenjodohkan";
import { connect } from "react-redux";
import {
	addQuestion,
	addQuestionMenjodohkan,
	addQuestionTrueFalse,
	addQuestionEssay,
	deleteQuestion,
	inputQuestion,
	inputKdUnit,
	inputVideoEmbed,
	addToListImg,
	addImageQues,
	removeImage,
	addImageFileQues,
} from "../../../store/actions/index";
import ImageUploader from "react-images-upload";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import axiosInstance from "../../../store/services/AxiosService";
import imageCompression from "browser-image-compression";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { config1 } from "../component/ConfigEditor";
import Ball from "../../../assets/Ball.svg";
import { withRouter } from "react-router-dom";


const baseImgURL = process.env.REACT_APP_BACKEND_IMAGES2;
class Question extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			kdUnit: null,
			kdId: null,
			kdDescription: null,
			kompetensiDasarOptions: [],
			unitDetailsOptions: [],
			savedKdUnits: [],
			isLoadingKD: false,
		};
	}

	editor = null;
	handleChangeInput = (keyPart, indexQuestion, text) => {
		this.props.inputQuestion(this.getIndex(keyPart), indexQuestion, text);
	};

	convertToEmbedUrl(url) {
		if (!url) return '';
		// YouTube: watch?v=, youtu.be/, embed/
		const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/);
		if (youtubeMatch) return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
		// Already an embed URL
		if (url.includes('/embed/') || url.includes('/embed?')) return url;
		// Google Drive video
		const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
		if (driveMatch) return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
		return url;
	}

	handleVideoEmbed = (keyPart, indexQuestion, text) => {
		this.props.inputVideoEmbed(this.getIndex(keyPart), indexQuestion, text);
	};

	handleIconAddImg = (indexPart, indexQues) => {
		this.props.addImageQues(indexPart, indexQues, null);
	};

	getIndex = (key) => {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		return Index;
	};

	async handleUploadImg(e, indexPart, indexQues, fileOld, fileNew) {
		e.preventDefault();
		if (fileNew !== null || fileNew !== undefined) {
			this.props.addImageQues(indexPart, indexQues, "Loading");
			const options = {
				maxSizeMB: 1,
				maxWidthOrHeight: 720,
				useWebWorker: true,
			};
			const compressedFile = await imageCompression(fileNew, options);
			var imgCompressed = new File([compressedFile], "uploaded_file.jpg", {
				type: "image/jpeg",
				lastModified: Date.now(),
			});
			let data = new FormData();
			data.append("file_attached", imgCompressed);
			data.append("old_file", fileOld);
			const url = "/files/upload";
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};
			axiosInstance
				.post(url, data, config)
				.then((r) => {
					this.props.addImageQues(indexPart, indexQues, r.data.file);
					this.props.addImageFileQues(indexPart, indexQues, null);
					this.props.addToListImg(r.data.file);
				})
				.catch((error) => {
					alert(`Proses upload gagal`);
				});
		}
	}

	async handleDeleteImage(e, fileName, indexPart, indexQues) {
		e.preventDefault();
		if (fileName !== null) {
			const data = { file_name: fileName };
			const url = "/files/delete";
			axiosInstance
				.post(url, data)
				.then((r) => {
					this.props.removeImage(indexPart, indexQues);
				})
				.catch((error) => {
					alert(`Proses delete gagal => ${error.message}`);
				});
		} else {
			this.props.removeImage(indexPart, indexQues);
		}
	}

	handleResetQuestion(case_question_id) {
		if (case_question_id == null) return
		this.setState((prevState) => {
			const newUnitDetailsOptions = { ...prevState.unitDetailsOptions };
			delete newUnitDetailsOptions[case_question_id];
			return {
				savedKdUnits: {
					...prevState.savedKdUnits,
					[case_question_id]: { api_kd_id: null, api_unit_id: null, description: null },
				},
				unitDetailsOptions: newUnitDetailsOptions,
			};
		});
	}

	handleAddQuestion(index) {
		const data = this.state.savedKdUnits;
		const unitOpts = this.state.unitDetailsOptions;
		const newEntry = { api_kd_id: null, api_unit_id: null, description: null }

		const newData = {};
		const newUnitOpts = {};
		const insertAt = index + 1;

		// Shift savedKdUnits keys
		Object.keys(data)
			.map(Number)
			.sort((a, b) => b - a)
			.forEach(key => {
				if (key >= insertAt) {
					newData[key + 1] = data[key];
				} else {
					newData[key] = data[key];
				}
			});
		newData[insertAt] = newEntry;

		// Shift unitDetailsOptions keys in the same way
		Object.keys(unitOpts)
			.map(Number)
			.sort((a, b) => b - a)
			.forEach(key => {
				if (key >= insertAt) {
					newUnitOpts[key + 1] = unitOpts[key];
				} else {
					newUnitOpts[key] = unitOpts[key];
				}
			});

		const sortedData = Object.keys(newData)
			.sort((a, b) => Number(a) - Number(b))
			.reduce((acc, key) => {
				acc[key] = newData[key];
				return acc;
			}, {});

		this.setState({
			savedKdUnits: sortedData,
			unitDetailsOptions: newUnitOpts,
		});
	}

	onDrop(pictureFiles, pictureDataURLs, indexPart, indexQues) {
		this.props.addImageFileQues(indexPart, indexQues, pictureFiles[0]);
	}

	localStorageSpace() {
		var data = "";
		for (var key in window.localStorage) {
			if (window.localStorage.hasOwnProperty(key)) {
				data += window.localStorage[key];
				// console.log(
				// 	key +
				// 		" = " +
				// 		((window.localStorage[key].length * 16) / (8 * 1024)).toFixed(2) +
				// 		" KB"
				// );
			}
		}
		console.log(
			data
				? "\n" +
				"Total space used: " +
				((data.length * 16) / (8 * 1024)).toFixed(2) +
				" KB"
				: "Empty (0 KB)"
		);
		console.log(
			data
				? "Approx. space remaining: " +
				(5120 - ((data.length * 16) / (8 * 1024)).toFixed(2)) +
				" KB"
				: "5 MB"
		);
	}

	componentDidMount() {
		let class_grade = this.props.cases?.class_grade_id !== undefined ? this.props.cases?.class_grade_id : this.props.match.params.class_grade_id;
		const school_id = this.props.cases?.school_id || this.props.schoolId;
		this.fetchKdUnit(this.props.cases?.course_id, class_grade, school_id);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.cases?.course_id !== this.props.cases?.course_id ||
			prevProps.cases?.class_grade_id !== this.props.cases?.class_grade_id
		) {
			let class_grade = this.props.cases?.class_grade_id !== undefined ? this.props.cases?.class_grade_id : this.props.match.params.class_grade_id;
			const school_id = this.props.cases?.school_id || this.props.schoolId;
			this.fetchKdUnit(this.props.cases?.course_id, class_grade, school_id);
		}
	}

	fetchKdUnit(idCourse, idClass, idSchool) {
		if (!idClass || !idCourse || !idSchool || idClass === 'null' || idClass === 'undefined') return;
		if (this.state.isLoadingKD) return; // Prevent duplicate concurrent calls
		let url = `/kompetensi-dasar/course/${idCourse}/class/${idClass}/school/${idSchool}`;
        if (this.props.match && this.props.match.params && this.props.match.params.schedule_id) {
            url += `?schedule_id=${this.props.match.params.schedule_id}`;
        }
		this.setState({ isLoadingKD: true });
		axiosInstance
			.get(url)
			.then((r) => {
				this.setState({ kdUnit: r.data || [], isLoadingKD: false });
				this.initializeKompetensiDasar(r.data || []);
			})
			.catch((error) => {
				this.setState({ isLoadingKD: false, kdUnit: [] });
				console.warn(`Fetch KD gagal: ${error.message}`);
			});
	}

	initializeKompetensiDasar(data) {
		const listKD = data || this.state.kdUnit || [];
		const mappedKD = listKD.map((item) => ({
			kompetensi_dasar_id: item.kompetensi_dasar_id,
			description: item.description,
			unit_details: item.unit_details || []
		}));
		this.setState({ kompetensiDasarOptions: mappedKD });
	}

	handleKompetensiDasarChange = (event, indexQuestion) => {
		const selectedKompetensiDasarId = event.target.value;
		const selectedKompetensiDasarText = event.target.options[event.target.selectedIndex].text;

		this.props.inputKdUnit(this.getIndex(this.props.keyID), indexQuestion, selectedKompetensiDasarId, selectedKompetensiDasarText, null, null, null);
	};

	handleKompetensiDasarUnitChange = (event, keyPart, indexQuestion, currentKdId) => {
		const selectedKompetensiDasarUnitId = event.target.value;
		const selectedKompetensiDasarUnitText = event.target.options[event.target.selectedIndex].text;

		const kdInfo = this.state.kompetensiDasarOptions.find((item) => String(item.kompetensi_dasar_id) === String(currentKdId));
		const kdDescription = kdInfo ? kdInfo.description : '';
		const unitDetails = kdInfo ? kdInfo.unit_details : [];
        const unitItem = unitDetails.find(i => String(i.kompetensi_dasar_detail_id || i.unit_detail_id) === String(selectedKompetensiDasarUnitId));
        const unitDesc = (unitItem?.long_description && unitItem.long_description !== '-') ? unitItem.long_description : (unitItem?.description || unitItem?.short_description || null);
        const unitString = unitItem?.unit || null;

		this.props.inputKdUnit(this.getIndex(keyPart), indexQuestion, currentKdId, kdDescription, selectedKompetensiDasarUnitId, unitDesc, unitString);
	}

	render() {
		this.localStorageSpace();
		const {
			case_part,
			keyID,
			typeCase,
			deleteQuestion,
			addQuestion,
			addQuestionMenjodohkan,
			addQuestionTrueFalse,
			addQuestionEssay,
		} = this.props;
		const partIndex = this.getIndex(keyID);
		if (!case_part || case_part.length === 0 || partIndex === -1 || !case_part[partIndex]) {
			return null;
		}

		return (
			<div>
				{case_part[partIndex].case_questions.map(
					(inputField, index) => (

						<div key={index + 1} className="card-question">

							{// dropdown KD
								!this.state.isLoadingKD && this.state.kdUnit ? <>
									<div>
										Capaian Pembelajaran {this.state.kompetensiDasarOptions.length === 0 ? '(Opsional)' : <span className="text-danger">* (Wajib)</span>}: <br></br>
										<select
											className={`custom-select custom-select-kd mr-sm-2 darkLine my-2 ${this.props.stillEmpty && this.state.kompetensiDasarOptions.length > 0 && !inputField.kd_id ? 'border-danger' : ''}`}
										id={"chooseKD" + inputField.key}
										onChange={(e) => this.handleKompetensiDasarChange(e, index)}
										value={inputField.kd_id || ''}
										>
											<option value="">Pilih Capaian Pembelajaran</option>
											{this.state.kompetensiDasarOptions.map((kd) => (
												<option key={kd.kompetensi_dasar_id} value={kd.kompetensi_dasar_id}>
													{kd.description || `CP Tanpa Deskripsi`}
												</option>
											))}
										</select>
									</div>
									<div>
										{/* Second Dropdown: Unit Details */}
										Tujuan Pembelajaran (TP) {this.state.kompetensiDasarOptions.length === 0 ? '(Opsional)' : (this.props.tipePenilaian === 'TP' ? <span className="text-danger">* (Wajib)</span> : '(Opsional)')}: <br></br>
										<select
											className={`custom-select custom-select-kd-unit mr-sm-2 darkLine my-2 ${this.props.stillEmpty && this.state.kompetensiDasarOptions.length > 0 && this.props.tipePenilaian === 'TP' && !inputField.kd_unit_id ? 'border-danger' : ''}`}
										id={"chooseKDUnit" + inputField.key}
										onChange={(e) => this.handleKompetensiDasarUnitChange(e, keyID, index, inputField.kd_id)}
										value={inputField.kd_unit_id || ''}
										>
										<option value="">Pilih Tujuan Pembelajaran (TP)</option>
										{((this.state.kompetensiDasarOptions.find(item => String(item.kompetensi_dasar_id) === String(inputField.kd_id))?.unit_details) || []).map((unit) => (
											<option key={unit.kompetensi_dasar_detail_id || unit.unit_detail_id} value={unit.kompetensi_dasar_detail_id || unit.unit_detail_id}>
												{unit.unit}{unit.indikator != null ? `.${unit.indikator}` : ''} - {unit.description}
											</option>
										))}
										</select>
									</div>
									<p className="mt-2 mb-5">{inputField.kd_unit_description || ''}</p>
								</> : (
									(this.props.cases?.class_grade_id && this.props.cases?.course_id) ? (
										<div className="text-center">
											<img src={Ball} alt=""></img>
										</div>
									) : (
										<div className="alert alert-warning text-center">
											Silakan <b>Pilih Kelas</b> dan <b>Mata Pelajaran</b> di bagian atas terlebih dahulu untuk memunculkan pilihan Capaian Pembelajaran (CP / TP).
										</div>
									)
								)
							}
							<div className="row mb-3">

								<div className={`col-md-auto align-self-start pt-1 ${this.props.stillEmpty && (inputField.question === null || inputField.question === "") ? 'bg-danger' : ''}`}>
									<h3 className="text-right ">{index + 1}.</h3>
								</div>

								<div className="col-md-9">
									<CKEditor
										id={"questionInput" + keyID + index}
										editor={ClassicEditor}
										data={
											inputField.question === null
												? ""
												: inputField.question
										}
										config={config1}
										onChange={(event, editor) => {
											const data = editor.getData();
											this.handleChangeInput(keyID, index, data);
										}}
										required
									/>
									<div>
										<input className="form-control form-group border-top" style={{ "boxShadow": "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px" }} value={inputField.video_embed === null
											? ""
											: inputField.video_embed} onChange={(e) => this.handleVideoEmbed(
												keyID,
												index,
												e.target.value
											)} placeholder="Video URL (YouTube, Google Drive, dll)" />
									</div>
									{inputField.video_embed && inputField.video_embed.trim() !== '' && (
										<div className="video-preview mt-2 mb-2">
											<iframe
												width="100%"
												height="315"
												src={this.convertToEmbedUrl(inputField.video_embed)}
												title="Video Preview"
												frameBorder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
												allowFullScreen
												style={{ borderRadius: '8px', border: '1px solid #ddd' }}
											></iframe>
										</div>
									)}

									{inputField.status_img === 1 ? (
										<div className="d-flex align-items-start m-3">
											<div className="box-imageQuestionPreview ">
												<Zoom isZoomed={true}>
													<div className="imageQuestionPreview ">
														{inputField.file_attached === null ||
															inputField.file_attached === "Loading" ? (
															<div>
																<span>Preview Gambar</span>
																{/* )} */}
															</div>
														) : (
															<img
																src={baseImgURL + inputField.file_attached}
																alt=""
																id="my-canvas"
															/>
														)}
													</div>
												</Zoom>
											</div>

											<div className="imgUploader ml-3">
												<ImageUploader
													className="imgUploader d-inline"
													name="quesImg"
													withIcon={true}
													singleImage={true}
													withPreview={true}
													buttonText="Pilih Gambar"
													onChange={(pictureFiles, pictureDataURLs) =>
														this.onDrop(
															pictureFiles,
															pictureDataURLs,
															this.getIndex(keyID),
															index
														)
													}
													imgExtension={[".jpg", ".jpeg", ".png"]}
													maxFileSize={2242880}
													fileSizeError="Ukuran File Terlalu Besar"
													label="Ukuran Maks: 2mb dengan format file .jpeg/.jpg/.png"
												/>
												<button
													className="btn btn-gradient-danger btn-sm mr-1 "
													onClick={(e) =>
														this.handleDeleteImage(
															e,
															inputField.file_attached,
															this.getIndex(keyID),
															index
														)
													}
												>
													Hapus Gambar
												</button>
												<button
													className="btn btn-gradient-primary btn-sm"
													onClick={(e) =>
														this.handleUploadImg(
															e,
															this.getIndex(keyID),
															index,
															inputField.file_attached,
															inputField.img_file
														)
													}
													disabled={
														inputField.img_file === null ||
															inputField.img_file === undefined
															? true
															: false
													}
												>
													{inputField.file_attached === "Loading" ? (
														<div>
															<i className="mdi mdi-loading mdi-spin"></i>{" "}
															Upload Gambar{" "}
														</div>
													) : (
														"Upload Gambar"
													)}
												</button>
											</div>
										</div>
									) : null}
								</div>
								<div className="col-md-auto">
									{typeCase === "menjodohkan" ? "" :
										<IconButton
											onClick={() =>
												this.handleIconAddImg(this.getIndex(keyID), index)
											}
										>
											<ImageIcon />
										</IconButton>
									}

									{index !== 0 && (
										<IconButton
											onClick={() => {
												deleteQuestion(this.getIndex(keyID), index)
												this.handleResetQuestion(index)
											}}
										>
											<RemoveIcon />
										</IconButton>
									)}
									{typeCase === "uraian" ? (
										<IconButton
											onClick={() => {
												addQuestionEssay(this.getIndex(keyID), index, inputField)
												this.handleAddQuestion(index)
											}}
										>
											<AddIcon />
										</IconButton>
									) : typeCase === "pilihan ganda benar salah" ? (
										<IconButton
											onClick={() => {
												addQuestionTrueFalse(this.getIndex(keyID), index, case_part[this.getIndex(keyID)].type_name, inputField)
												this.handleAddQuestion(index)
											}}
										>
											<AddIcon />
										</IconButton>
									) : typeCase === "menjodohkan" ? (
										<IconButton
											onClick={() => {
												addQuestionMenjodohkan(this.getIndex(keyID), index, case_part[this.getIndex(keyID)].type_name, inputField)
												this.handleAddQuestion(index)
											}}
										>
											<AddIcon />
										</IconButton>
									) : (
										<IconButton
											onClick={() => {
												addQuestion(this.getIndex(keyID), index, case_part[this.getIndex(keyID)].type_name, inputField)
												this.handleAddQuestion(index)
											}}
										>
											<AddIcon />
										</IconButton>
									)}
								</div>
							</div>
							{typeCase === "pilihan ganda" ? (
								<TestChoices
									stillEmpty={this.props.stillEmpty}
									keyID={keyID}
									indexQues={index}
									indexPart={this.getIndex(keyID)}
								/>
							) : typeCase === "pilihan ganda benar salah" ? (
								<TestChoicesTrueFalse
									stillEmpty={this.props.stillEmpty}
									keyID={keyID}
									indexQues={index}
									indexPart={this.getIndex(keyID)}
								/>
							) : typeCase === "pilihan ganda kompleks" ? (
								<TestChoicesMultiple
									stillEmpty={this.props.stillEmpty}
									keyID={keyID}
									indexQues={index}
									indexPart={this.getIndex(keyID)}
								/>
							) : typeCase === "isian singkat" ? (
								<TestShortAnswer
									stillEmpty={this.props.stillEmpty}
									keyID={keyID}
									indexQues={index}
									indexPart={this.getIndex(keyID)}
								/>
							) : typeCase === "menjodohkan" ? (
								<TestMenjodohkan
									stillEmpty={this.props.stillEmpty}
									keyID={keyID}
									indexQues={index}
									indexPart={this.getIndex(keyID)}
								/>
							) : ""}

							<br></br>
						</div>
					)
				)}
			</div>
		);
	}
}

const mapToStateToProps = (state) => {
	return {
		case_part: state.Exam.case_part,
		cases: state.Exam.cases,
		schoolId: state.User.dataSchool?.value,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addQuestion: (index, indexQues, typeCase, inputField) => dispatch(addQuestion(index, indexQues, typeCase, inputField)),
		addQuestionTrueFalse: (index, indexQues, typeCase, inputField) => dispatch(addQuestionTrueFalse(index, indexQues, typeCase, inputField)),
		addQuestionMenjodohkan: (index, indexQues, typeCase, inputField) => dispatch(addQuestionMenjodohkan(index, indexQues, typeCase, inputField)),
		addQuestionEssay: (index, indexQues) =>
			dispatch(addQuestionEssay(index, indexQues)),
		deleteQuestion: (index, indexQues) =>
			dispatch(deleteQuestion(index, indexQues)),
		inputQuestion: (index, indexQues, text) =>
			dispatch(inputQuestion(index, indexQues, text)),
		inputVideoEmbed: (index, indexQues, text) =>
			dispatch(inputVideoEmbed(index, indexQues, text)),
		addToListImg: (imageName) => dispatch(addToListImg(imageName)),
		addImageQues: (index, indexQues, image) =>
			dispatch(addImageQues(index, indexQues, image)),
		addImageFileQues: (index, indexQues, imageFile) =>
			dispatch(addImageFileQues(index, indexQues, imageFile)),
		removeImage: (index, indexQues) => dispatch(removeImage(index, indexQues)),
		inputKdUnit: (index, indexQues, kdId, kdDescription, kdUnitId, kdUnitDescription) =>
			dispatch(inputKdUnit(index, indexQues, kdId, kdDescription, kdUnitId, kdUnitDescription)),
	};
};
export default connect(mapToStateToProps, mapDispatchToProps)(withRouter(Question));
